import { BaseModel } from './base.model'
import * as _ from 'lodash'
import { Constants } from 'config'
import { Program } from './program.model'
import { HubWeekDay } from './hub-week-day.model'
import { HubTimeInterval } from './hub-time-interval.model'
import { Moment } from 'moment'

export class HubCourseTimetable extends BaseModel<HubCourseTimetable> {
   static DEFAULT_ATTRIBUTES = {
    hubWeekDays: Array.from(Array(7).keys()).map((v) => new HubWeekDay({ordinal: v})),
    hoursSlot: 0,
    minutesSlot: 30

  }

  id: number
  hubCourseId: number
  hoursSlot: number
  minutesSlot: number
  registerSmsText: string
  registerFrom: Moment
  registerTo: Moment
  hubWeekDays: HubWeekDay[]
  cyclic: boolean
  scheduleText: string
  ahead: number

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/models/hub-course-timetable.model.ts